import { ItemRewardType } from '@/cowboy/EnumTypes'

export const ECARD_REWARD_TYPES = Object.freeze([
  ItemRewardType.ALL,
  ItemRewardType.CASH_EQUIV,
  ItemRewardType.GIFT_CARD
])

export const PAYMENT_REWARD_TYPES = Object.freeze([
  ItemRewardType.PAYMENT_ACH,
  ItemRewardType.PAYMENT_DEBIT_CARD
])
